import { useCallback, useMemo } from 'react';
import { useGetGroupFoldersQuery } from '@app-types/blackroom-api';
import useWorkspace from '@features/Workspace/store/hooks/useWorkspace';
import {
  buildFoldersMap,
  getGroupDisplayName,
} from '../helpers/getGroupDisplayName';

export default function useGroupDisplayName() {
  const workspace = useWorkspace();

  const { data: foldersData } = useGetGroupFoldersQuery({
    variables: { workspaceId: workspace.id },
    fetchPolicy: 'cache-first',
  });

  const foldersMap = useMemo(
    () => buildFoldersMap(foldersData?.groupFolders ?? []),
    [foldersData],
  );

  const getDisplayName = useCallback(
    (group: { name: string; folderId?: string | null }): string =>
      getGroupDisplayName(group, foldersMap),
    [foldersMap],
  );

  return { getDisplayName, foldersMap };
}
